<div class="qira-dialog">

  <div class="qira-dialog__header">
    <mat-icon class="qira-dialog__icon">info_outline</mat-icon>
    <p class="qira-dialog__message" [innerHTML]="model.message"></p>
  </div>

  <div class="qira-dialog__actions">
    <button mat-stroked-button class="qira-dialog__cancel" (click)="onCancel()">{{ closeButtonText }}</button>
    <button mat-flat-button color="primary" class="qira-dialog__confirm" (click)="onAction()">{{ model.okButtonText }}</button>
  </div>

</div>
